import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBolt,
  faCalendarAlt,
  faEdit,
  faWrench,
  faCirclePlus,
  faClock,
  faCircleMinus,
  faDiceD6,
} from '@fortawesome/free-solid-svg-icons';
import 'font-awesome/css/font-awesome.min.css';
import '../css/main.css';

const TimeLog = ({ data }) => {
  const history = (() => {
  if (Array.isArray(data?.history)) return data.history;
  if (typeof data?.history === 'string') {
    try {
      const parsed = JSON.parse(data.history);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
})();


const getIconData = (field) => {
  if (field === 'priority') return { icon: faBolt, color: 'text-yellow-500' };
  if (field === 'status') return { icon: faDiceD6, color: 'text-yellow-500' };
  if (['start_date', 'due_date'].includes(field)) return { icon: faCalendarAlt, color: 'text-blue-500' };
  if(field === 'submission_date') return {icon: faClock, color: 'text-green-500'};
  if (field === 'task_name') return { icon: faEdit, color: 'text-red-500' };
  if (field === 'Done Time') return { icon: faCircleMinus, color: 'text-red-500' };
  return { icon: faWrench, color: 'text-gray-500' };
};

  // Deduplicate similar field changes at same minute
  const seen = new Map();
  const uniqueHistory = [];

  for (let i = history.length - 1; i >= 0; i--) {
    const entry = history[i];
    const timeKey = entry.updated_at?.slice(0, 16); // YYYY-MM-DD HH:MM
    const changes = entry.changes || {};

    for (const [field, value] of Object.entries(changes)) {
      const key = `${field}_${timeKey}`;
      if (!seen.has(key)) {
        seen.set(key, true);
        uniqueHistory.push({ field, value, updated_at: entry.updated_at });
      }
    }
  }
  const getFieldLabel = (field) => {
  if (field === 'submission_date') return 'Tentative Time';
  if (field === 'due_date') return 'Submission Date';
  return field.replace(/_/g, ' ');
};

  return (
    <div className='border border-gray-200 p-4 bg-gray-50 h-full min-h-screen rounded-tr-2xl'>
      {/* Task Header */}
      <div className='flex mb-4'>
        <FontAwesomeIcon icon={faCirclePlus} className='text-green-400 text-xl pr-2' />
        <div className='flex shadow-md w-full bg-white '>
          <div className='text-gray-700 text-sm border-l pl-2 py-2 pt-1 w-32'>
            <p className='font-semibold'>Task Created:</p>
            <p className='text-[9px] ml-8'>By {data.assign_by}</p>
          </div>
          <div className='text-xs ml-4 font-semibold mt-1'>
            <p>{data.task_name}</p>
            <p className='bg-gray-100 text-[10px] w-40 px-3 py-[1px] mt-1 rounded ml-5 font-medium mb-2'>
              Time: {data.timestamp || 'No Time'}
            </p>
          </div>
        </div>
      </div>

      {/* History Log */}
      <div className='mt-2'>
        {uniqueHistory.length === 0 ? (
          <p className='text-gray-400 text-sm'>No history available.</p>
        ) : (
          <ul className='space-y-5 text-sm'>
           {uniqueHistory.reverse().map((item, idx) => {
  const { icon, color } = getIconData(item.field);
  return (
    <li key={idx}>
      <div className='flex items-start gap-2'>
        <FontAwesomeIcon icon={icon} className={`${color} mt-1 ml-1 text-lg`} />
        <div className='bg-white p-3 shadow-lg border-l border-gray-700 w-full text-xs'>
          <p className='text-gray-700 font-semibold'>
<span className='capitalize text-gray-500'>{getFieldLabel(item.field)}:</span>
            <span className='ml-2 text-gray-600 text-xs'>
              {item.value.from || <em>empty</em>} <span className='mx-1'>→</span> {item.value.to || <em>empty</em>}
            </span>
          </p>
          <p className='text-gray-400 text-xs mt-1'>
            Updated at: {item.updated_at}
          </p>
        </div>
      </div>
    </li>
  );
})}

          </ul>
        )}
      </div>
    </div>
  );
};

export default TimeLog;
